import { get } from 'utils/api';

export const getDashboardV2Performance = () => {
  return get('/dashboard/v2/performance');
};

export const getDashboardV2Stations = (data) => {
  return get('/dashboard/v2/stations', data);
};

export const dashboardV2 = {
  getDashboardV2Performance,
  getDashboardV2Stations,
};
